import { useMutation } from "@tanstack/react-query";
import { downloadcvsService } from "@/services/downloadcvsService";

export const useDownloadCVs = () => {
  return useMutation({
    mutationFn: ({ ids, vacancyId, filters }) => downloadcvsService.downloadcvs(ids, vacancyId, filters),
    onSuccess: (data) => {
      // Handle success, e.g., show a success message or trigger a download
      console.log("CVs downloaded successfully:", data);
    },
    onError: (error) => {
      // Handle error, e.g., show an error message
      console.error("Failed to download CVs:", error);
    },
  });
}; 